<div class="row customer-page__row">
  <div class="col-12 offset-lg-2 col-lg-8 customer-page__intro">
    <h3 *appApplyIfNotEmpty="translationService.getTranslation('customerView_intro')"
      [innerHTML]="translationService.getTranslation('customerView_intro')"
      class="customer-page__intro-title"></h3>
  </div>
  <div class="col-12 offset-lg-2 col-lg-8 customer-page__description">
    <p [innerHTML]="translationService.getTranslation('customerPage_description')"
      class="customer-page__description-title"></p>
  </div>
</div>

<div id="customer-page" class="customer-page">
  <div class="row customer-page__row">
    <div class="{{ (hasCustomResponsivClasses() ? getCustomResponsivClasses() : 'col-12 offset-lg-2 col-lg-8' ) + ' mb-4 customer-page__card-col' }}">
      <mat-card
        appearance="outlined"
        class="pointer h-100 customer-page__card"
        (click)="navigateToInvoices()"
      >
        <mat-card-header class="customer-page__card-header">
          <mat-card-title
            [innerHTML]="translationService.getTranslation('invoices')"
            class="customer-page__card-title"
          >
          </mat-card-title>
        </mat-card-header>
        <mat-card-content
          [innerHTML]="translationService.getTranslation('invoices_description')"
          class="customer-page__card-content"
        >
        </mat-card-content>
      </mat-card>
    </div>
  </div>
</div>
